export default __webpack_public_path__ + "static/media/B-Furnished.2669c566.png";